import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { KmxContainer } from '../KmxContainer';
import useAppState from '../../common/state/appState';

type Props = {
    children: ReactNode;
    noPaddingMobile?: boolean;
};

const CoverSection = ({ children, noPaddingMobile = false }: Props) => {
    const serveUFTContentEnabled = useAppState((state) => state.serveUFTContent);

    const getPaddingX = () => {
        if (noPaddingMobile) return { xs: 0, sm: 5, md: 8 };
        if (serveUFTContentEnabled) return undefined;
        return { xs: 0, sm: 2 };
    };

    return (
        <KmxContainer
            maxWidth="xl"
            sx={{
                px: getPaddingX(),
                mt: serveUFTContentEnabled ? { xs: 5, sm: 6 } : { xs: 5, sm: 8 },
            }}
        >
            <Box
                id="coverSection"
                sx={{
                    p: { xs: 3, md: 6 },
                    pb: { xs: 0, sm: 3, md: 6 },
                    borderRadius: { xs: 0, sm: 2.5 },
                    backgroundPosition: { xs: 'top center', md: 'center center' },
                    backgroundSize: { xs: 'contain', sm: 'cover' },
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: {
                        xs: `url(/home/images/home/instant-offers/io-mobile.jpg)`,
                        sm: `url(/home/images/home/instant-offers/io-desktop.jpg)`,
                    },
                }}
            >
                <Box
                    sx={{ pt: { xs: 21, sm: 0 }, width: { xs: '100%' } }}
                    data-fs-section="HP: Instant Offers"
                    id="io-featured-story-telling-section"
                >
                    {children}
                </Box>
            </Box>
        </KmxContainer>
    );
};

export default CoverSection;
